module.exports = __webpack_public_path__ + "img/indigo.ff3f7152.png";